var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex h-full" },
    [
      _c("catalog-sidebar", {
        staticClass:
          "absolute z-10 w-full px-4 bg-white lg:static lg:px-0 lg:w-64 lg:bg-transparent lg:z-0",
        on: { "filter-changed": _vm.filterChanged }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-col pt-16 lg:pt-0" }, [
        _c(
          "div",
          { staticClass: "relative flex flex-col self-end pl-4 mb-4" },
          [
            _c(
              "div",
              {
                staticClass: "flex items-baseline cursor-pointer",
                on: {
                  click: function($event) {
                    _vm.chooseSort = !_vm.chooseSort
                  }
                }
              },
              [
                _c("h3", { staticClass: "mr-2 text-xl lg:text-2xl" }, [
                  _vm._v(_vm._s(_vm.sortingName))
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "transition-transform duration-500 transform",
                  class: { "rotate-180": _vm.chooseSort },
                  attrs: {
                    src: require("../../../images/chevron_down.svg").default,
                    alt: "Chevron"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "absolute left-0 right-0 z-10 overflow-hidden bg-white accordion",
                class: { opened: _vm.chooseSort },
                staticStyle: { top: "100%" }
              },
              _vm._l(_vm.sortingOptions, function(option, key) {
                return _c("div", { key: "sorting-option-" + key }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "pl-4 my-2 cursor-pointer hover:text-brandRed",
                      on: {
                        click: function($event) {
                          return _vm.changeSort(option.slug)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(option.title) + "\n          "
                      )
                    ]
                  )
                ])
              }),
              0
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "relative pr-2 -mr-2 overflow-y-scroll lg:-mr-8 lg:pr-8",
            on: { scroll: _vm.lazyloadProducts }
          },
          [
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.filtering
                ? _c(
                    "div",
                    {
                      staticClass:
                        "absolute top-0 bottom-0 left-0 right-0 z-10 flex flex-col items-center justify-center"
                    },
                    [
                      _c("div", {
                        staticClass:
                          "absolute top-0 bottom-0 left-0 right-0 bg-white opacity-75"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-center mt-8 space-x-4"
                        },
                        [
                          _c("div", { staticClass: "animate-pulse" }, [
                            _c("div", {
                              staticClass:
                                "w-3 h-3 rounded-full bg-brandRed animate-bounce"
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "animate-pulse" }, [
                            _c("div", {
                              staticClass:
                                "w-3 h-3 rounded-full bg-brandRed animate-bounce"
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "animate-pulse" }, [
                            _c("div", {
                              staticClass:
                                "w-3 h-3 rounded-full bg-brandRed animate-bounce"
                            })
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "transition-group",
              {
                staticClass: "grid grid-cols-1 gap-5 lg:grid-cols-3",
                attrs: { name: "fade", tag: "div" }
              },
              _vm._l(_vm.filteredProducts, function(product, key) {
                return _c(
                  "div",
                  {
                    key: "product-" + key,
                    staticClass: "grid grid-cols-12 gap-5"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "col-span-5 overflow-hidden",
                        attrs: { href: product.permalink }
                      },
                      [
                        _c("img", {
                          staticClass:
                            "w-full h-auto transition-transform duration-500 transform hover:scale-110",
                          attrs: { src: product.catalog_image, alt: "" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col justify-around flex-grow col-span-7"
                      },
                      [
                        _c("div", [
                          _c("a", { attrs: { href: product.permalink } }, [
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "mb-2 xl:w-3/4 lg:text-lg xl:text-xl"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(product.name) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { style: "color: " + product.color_family + ";" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(product.categories[0].name) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatPrice(product.regular_price)) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.loadingNew && !_vm.noMoreResults
              ? _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-center mt-8 space-x-4"
                  },
                  [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "animate-pulse" }, [
      _c("div", {
        staticClass: "w-3 h-3 rounded-full bg-brandRed animate-bounce"
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "animate-pulse" }, [
      _c("div", {
        staticClass: "w-3 h-3 rounded-full bg-brandRed animate-bounce"
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "animate-pulse" }, [
      _c("div", {
        staticClass: "w-3 h-3 rounded-full bg-brandRed animate-bounce"
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib?{}!./scripts/vue/catalog/App.vue?vue&type=template&id=1dc456b2&
// module id = 142
// module chunks = 0